   import {AfterViewInit, Component, OnInit} from '@angular/core';
   import {dataFakeLoyalty, ResponseData} from './dto/loyalty.dto';
   import {AuthService} from '../../auth';
   import {fromEvent, timer} from 'rxjs';
   import {debounceTime, exhaustMap, map, switchMap, switchMapTo, take} from 'rxjs/operators';
   import {LoyaltyService} from '../../services/business/loyalty/loyalty.service';
   import {NzNotificationService} from 'ng-zorro-antd';

   @Component({
  selector: 'app-loyalty',
  templateUrl: './loyalty.component.html',
  styleUrls: ['./loyalty.component.scss']
})
export class LoyaltyComponent implements OnInit , AfterViewInit {

  constructor( private authService: AuthService, private loyaltyService: LoyaltyService ,  private notification: NzNotificationService, ) { }
  dataLoyalties: ResponseData;
  mainScreen ;
  firstScreen ;
  secondScreen = false;
  thirdScreen = false;
  fourthScreen = false;
  fifthScreen = false;
  phone: string;
  otp: string;
  token: string;
  countDown = 60;
  messageFail: string;
  page = 1;
  pageSize = 10;
  items;
  total = 0;
  messageFailFourthScreen = 'Rất tiếc, liên kết tài khoản Loyalty thất bại. ' +
    'Vui lòng liên hệ với bộ phận chăm sóc khách hàng của iCheck để được hỗ trợ';
 async ngOnInit() {
       this.loyaltyService.checkRegisLoyalty().pipe(map(z => z.code), switchMap(code => {
         if (code !== 1) {
           this.firstScreen = false;
           this.secondScreen = false;
           this.fourthScreen = false;
           this.thirdScreen = false;
           this.mainScreen = false;
           this.fifthScreen = true;
           const query = {
             page: this.page,
             page_size: this.pageSize
           };
           return this.loyaltyService.getListLoyaltyWithProduct(query);
         }
         throw new Error('Valid token not returned');
       })).subscribe(proj => {

               this.dataLoyalties = proj;
               this.page = proj.currentPage || 1;
               this.total = proj.totalElement;
               this.pageSize = proj.pageSize;
               if (this.dataLoyalties.items) {
                 this.items = this.dataLoyalties.items.map(z => {
                   let statusName = '';
                   let color = '';
                   switch (z.status) {
                     case 'Đã Kết Thúc' : statusName = 'Đã Kết Thúc'; color = 'black'; break;
                     case 'Đang Diễn Ra' : statusName = 'Đang Diễn Ra'; color = 'green'; break;
                     case 'Chưa Bắt Đầu' : statusName = 'Chưa Bắt Đầu'; color = 'red'; break;
                   }
                   return {...z , statusName , color};
                 });
               }
       }, error => {
         this.mainScreen = true;
         this.firstScreen = true ;
       });
 }
  loadData(page, pageSize) {
    const query = {
      page,
      page_size: pageSize
    };
    this.loyaltyService.getListLoyaltyWithProduct(query).subscribe(proj => {
      this.dataLoyalties = proj;
      this.total = proj.totalElement;
      console.log('this.total', this.total)
      if (this.dataLoyalties.items) {
        this.items = this.dataLoyalties.items.map(z => {
          let statusName = '';
          let color = '';
          switch (z.status) {
            case 'Đã Kết Thúc' : statusName = 'Đã Kết Thúc'; color = 'black'; break;
            case 'Đang Diễn Ra' : statusName = 'Đang Diễn Ra'; color = 'green'; break;
            case 'Chưa Bắt Đầu' : statusName = 'Chưa Bắt Đầu'; color = 'red'; break;
          }
          return {...z , statusName , color};
        });
      }
    }, error => {
      this.mainScreen = true;
      this.firstScreen = true ;
    });

  }
  pageIndexChange(page) {
    this.loadData(page, this.pageSize)
  }
  pageSizeChange(pageSize) {
    this.loadData(this.page, pageSize)

  }
  authenticate() {
    const body = {
      token: this.token,
      otp: this.otp
    };
    this.loyaltyService.authenticateLoyalty(body).subscribe(z => {
       const {code , data , message } = z;
       if (code === 1) {
         this.secondScreen = false;
         this.thirdScreen = true;
         this.mainScreen = true;
       } else {
         return this.notification.create('warning', 'Cảnh báo', `${message}`);
       }
     });
  }
  sendCode() {
    const query = {
      phone: this.phone
    };
    this.loyaltyService.requestLoyalty(query).subscribe(z => {
      const {code , data, message }  = z;

      if (code === 1 ) {
        this.firstScreen = false;
        this.secondScreen = true;
        this.token = data.token;
        const interval =  setInterval(_ =>  {
          this.countDown--;
          if (this.countDown < 1) {
            this.fourthScreen = true;
            this.secondScreen = false;
            this.messageFailFourthScreen = 'Rất tiếc, phiên làm việc đã hết hạn ' +
              '. Vui lòng liên hệ với bộ phận chăm sóc khách hàng của iCheck để được hỗ trợ';
            clearInterval(interval);
          }
        }, 1000);
      } else {
        return this.notification.create('warning', 'Cảnh báo', `${message}`);
      }
    });
  }
  ngAfterViewInit(): void {
  }
}

